import axios from 'axios';
import supervisoralert from './supervisioralert.vue';
export default {
    name: 'AddSupervisor',
    props: ['item'],
    data() {
        return {
            list: []
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            //this.initialized = false;
            let suervisorUrl = APIURL + '/activity/attendants/-1';
            axios.post(suervisorUrl, this.item)
                .then(resp => {
                    this.list = resp.data;
                });
        },
        select(attendant) {
            console.log(attendant.isAvailable);
            if (attendant.isAvailable) {
                this.$vuedals.close({ attendantId: attendant.id, activityId: this.item.id, activityPeriodId: this.item.activityPeriodId });
            }
            else {
                let self = this;
                this.$vuedals.dismiss();
                this.$vuedals.open({
                    title: this.$t('title.schdulealert'),
                    props: {
                        attendant: attendant,
                        item: this.item
                    },
                    component: supervisoralert,
                    size: 'lg',
                    escapable: true,
                    onClose() {
                        
                    }
                });
            }
        }
    }
};